<template>
<div class="edit">
    <div>
        包名信息配置
    </div>
    <el-form class="detail" :model="detail" label-width="180px" :rules="rule" ref="form1" >
        <el-form-item :label="item.label" :prop="item.prop" v-for="item in infoConfig" v-if="!item.hide" style="margin-top: 20px">
            <el-input v-if="item.prop === 'id'" disabled :type="item.type" v-model="detail[item.prop]"></el-input>
            
            <!-- 明文包名 -->
            <el-input v-else-if="item.prop === 'plaintextPackageName'" :type="item.type" v-model="detail[item.prop]" :placeholder="item.placeholder"></el-input>
            
            <!-- 包名映射ID -->
            <el-input v-else-if="item.prop === 'packageNameMappingId'" :type="item.type" v-model="detail[item.prop]" :placeholder="item.placeholder"></el-input>
            
            <!-- 操作系统 -->
            <el-select v-else-if="item.prop === 'operatingSystem'" v-model="detail[item.prop]" :placeholder="item.placeholder">
                <el-option v-for="option in operatingSystemOptions" :key="option.id" :value="option.id" :label="option.name"/>
            </el-select>
            
            <!-- 是否明文回传 -->
            <el-select v-else-if="item.prop === 'isPlaintextCallback'" v-model="detail[item.prop]" :placeholder="item.placeholder">
                <el-option v-for="option in isPlaintextCallbackOptions" :key="option.id" :value="option.id" :label="option.name"/>
            </el-select>
            
            <!-- 是否生效 -->
            <el-select v-else-if="item.prop === 'isEffective'" v-model="detail[item.prop]" :placeholder="item.placeholder">
                <el-option v-for="option in isEffectiveOptions" :key="option.id" :value="option.id" :label="option.name"/>
            </el-select>
            
            <span v-if="item.tip">{{item.tip}}</span>
        </el-form-item>
    </el-form>
    <el-button style="margin-left: 100px" type="primary" @click="save" >保存</el-button>
    <el-button style="margin-left: 10px" @click="cancel" >取消</el-button>
</div>
</template>

<script>
import {sspApi} from '@/api';
import _ from 'lodash'

export default {
    data: function () {
        return {
            operatingSystemOptions: [
                {id: 'Android', name: 'Android'},
                {id: 'iOS', name: 'iOS'},
                {id: '鸿蒙', name: '鸿蒙'},
            ],
            isPlaintextCallbackOptions: [
                {id: '是', name: '是'},
                {id: '否', name: '否'},
            ],
            isEffectiveOptions: [
                {id: '是', name: '是'},
                {id: '否', name: '否'},
            ],
            detail: {
                id: undefined,
                plaintextPackageName: '',
                packageNameMappingId: '',
                operatingSystem: '',
                isPlaintextCallback: '否',
                isEffective: '是',
            },
            rule: {
                plaintextPackageName: [
                    { required: true, message: '请输入明文包名', trigger: 'blur' }
                ],
                operatingSystem: [
                    { required: true, message: '请选择操作系统', trigger: 'change' }
                ],
                isPlaintextCallback: [
                    { required: true, message: '请选择是否明文回传', trigger: 'change' }
                ],
                isEffective: [
                    { required: true, message: '请选择是否生效', trigger: 'change' }
                ],
            }
        }
    },
    created: function() {
        if (this.packageNameId) {
            // 编辑模式，加载数据
            sspApi.getPackageName({
                params: {id: this.packageNameId}
            }).then((response) => {
                _.assign(this.detail, response)
            }).catch(this.$rejectAjaxError());
        }
    },
    computed: {
        infoConfig: function () {
            return [
                {prop: 'id', label: '编号', tip: '提交后系统自动生成，无需填写'},
                {prop: 'plaintextPackageName', label: '明文包名', placeholder: '请输入明文包名'},
                {prop: 'packageNameMappingId', label: '包名映射ID', placeholder: '请输入包名映射ID（可选）'},
                {prop: 'operatingSystem', label: '操作系统', placeholder: '请选择操作系统'},
                {prop: 'isPlaintextCallback', label: '是否明文回传', placeholder: '请选择'},
                {prop: 'isEffective', label: '是否生效', placeholder: '请选择'},
            ]
        },
        packageNameId: function() {
            return this.$route.params.id
        },
    },
    methods: {
        save: function () {
            this.$refs.form1.validate((valid) => {
                if (valid) {
                    let apiMethod = this.packageNameId ? sspApi.editPackageName : sspApi.createPackageName;
                    apiMethod({data: this.detail}).then(() => {
                        //to list page
                        this.$router.push({ name: "installedListCallback"}).catch(() => {});
                    }).catch(this.$rejectAjaxError());
                } else {
                    this.$notify.error({ title: '验证失败', message: '请检查输入信息' });
                }
            });
        },
        cancel: function () {
            this.$router.push({ name: "installedListCallback"}).catch(() => {});
        },
    }
}
</script>
<style scoped>
    .detail {
       font-size: 10px;
       padding-left: 20px;
    }
    .detail >>> .el-col {
        height: 30px;
        width: 40%;
    }
    .detail >>> .el-input {
        width: 350px;
    }
    .detail >>> .el-select {
        width: 350px;
    }
    .detail span {
        margin-left: 10px;
        color: red
    }
</style>


